import { ref, computed } from 'vue'

export function useSeatSelection(plazas) {
    const plazasSeleccionadas = ref([])

    const asientos = computed(() => {
        return plazasSeleccionadas.value.map(p => p.id)
    })

    function clickButaca(plazaSeleccionada) {
        const plazaEncontrada = plazas.value.find(plaza => plaza.id === plazaSeleccionada.id)

        if (plazaEncontrada) {
            plazaEncontrada.seleccionada = !plazaEncontrada.seleccionada

            if (plazaEncontrada.seleccionada) {
                if (!plazasSeleccionadas.value.some(plaza => plaza.id === plazaSeleccionada.id)) {
                    plazasSeleccionadas.value.push(plazaSeleccionada)
                }
            } else {
                const index = plazasSeleccionadas.value.findIndex(plaza => plaza.id === plazaSeleccionada.id)
                if (index !== -1) {
                    plazasSeleccionadas.value.splice(index, 1)
                }
            }
        }
    }

    function selectAllButacas() {
        // eslint-disable-next-line no-unused-expressions
        (plazas.value || []).forEach(plaza => {
            // Fix: correct operator precedence — explicitly parenthesize the OR
            if (plaza.libre == true || (plaza.libre == false && plaza.ocupada && plaza.ocupada.bloqueada == true)) {
                clickButaca(plaza)
            }
        })
    }

    function clearAllButacas() {
        // Fix: iterate over plazas (not filas — filas never populated in this context)
        if (plazas.value) {
            plazas.value.forEach(plaza => {
                if (plaza.seleccionada) {
                    plaza.seleccionada = false
                }
            })
        }
        plazasSeleccionadas.value = []
    }

    return {
        plazasSeleccionadas,
        asientos,
        clickButaca,
        selectAllButacas,
        clearAllButacas
    }
}
